// extracted by mini-css-extract-plugin
export default {"table":"Annotations_table__rJaV8"};